import "./work-with-us-parallax.scss"
import {useState} from "react";
import ContactUsForm from "./contact-us-form";
import { Modal } from "react-bootstrap";
import {useNavigate} from "react-router-dom";

function WorkWithUs() {

    const [contactUsModal, setContactUsModal] = useState<boolean>(false);

    const navigate = useNavigate();

    const navigateToURL = (url: string) => {
        navigate(`/${url}`);
    }

    return (
        <>
          <Modal centered show={contactUsModal} dialogClassName={"contact-us-modal"}>
             <Modal.Body>
                <div className={"contact-us-modal-body"}>
                    {/* <button className={"close-btn"} onClick={() => {
                        setContactUsModal(false);
                    }}><i className="bi bi-x-lg"></i></button> */}

                    <ContactUsForm setContactUsModal={setContactUsModal} />
                </div>
             </Modal.Body>
          </Modal>

          <div className={"work-with-us-parallax"}>
              <div className={"work-with-us-content"}>
                  <div className={"work-with-us-heading"}>
                      <h2 className={"work-with-us-main-line"}>WORK WITH LUXORA DUBAI</h2>
                      <h4 className={"work-with-us-main-by-line"}>GLOBAL CONNECTIONS. LOCAL INSIGHT. EXCEPTIONAL LUXURY.</h4>
                  </div>
                  <div className={"work-with-us-footer"}>
                      <p className={"work-with-us-desc"}>Whether you're buying, selling, or investing, Luxora Dubai is your trusted partner in the world’s most dynamic real estate market. Our curated collection of ultra-premium properties and our deep understanding of Dubai’s evolving landscape ensure our clients get more than just a home — they gain access to an elite lifestyle.
                      From Palm Jumeirah to Downtown, from off-plan opportunities to record-breaking penthouses, Luxora maximizes your property's potential with unmatched precision and market strategy.</p>
                      <div className={"work-with-us-button-container"}>
                          <button className={"contact-us-btn"} onClick={() => {
                              setContactUsModal(true);
                          }}>CONTACT US</button>
                          <button className={"view-props-btn"} onClick={() => navigateToURL("property/list")}>VIEW PROPERTIES</button>
                      </div>
                  </div>
              </div>
          </div>
        </>
    )

}

export default WorkWithUs;